export const browserLocaleCodeToDateFnsLocaleCode = (v: string): string => {
  switch (v) {
    case "en":
      return "en-GB";
    default:
      return v;
  }
};
